module.exports = __webpack_public_path__ + "static/bg_tabs.9c195b0d.png";